
// ROUTES
require('modules/location/routes/location');

// CONTROLLERS
require('modules/location/controllers/location');
require('modules/location/controllers/list');
require('modules/location/controllers/create');
require('modules/location/controllers/edit');

// SERVICES
require('modules/location/services/location');
require('modules/location/services/list');
require('modules/location/services/create');
require('modules/location/services/edit');
require('modules/location/services/delete');


angular.module('unica_location', [

	'uiGmapgoogle-maps',

	// ROUTES
	'unica_location.location_routes',

	// CONTROLLERS
	'unica_location.location_controllers',

	// SERVICES
	'unica_location.location_services'

]);